import {
    StyledAvatar,
    StyledName,
    StyledSocialCard,
    StyledButtonContainer,
} from './SocialMediaCard.styles';
import {
    Typography,
    IconButton,
    Button,
    Icon,
    useTheme,
} from '../../../../base';
import { SocialMediaPlatforms } from '../../../../common';
import { useTranslation } from 'react-i18next';

interface SocialMediaCardProps {
    name: SocialMediaPlatforms;
    avatar: string;
    isConnected: boolean;
}

const SocialMediaCard = (props: SocialMediaCardProps) => {
    const { name, avatar, isConnected } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <StyledSocialCard>
            <StyledAvatar src={avatar} name={name} alt={name} />
            <StyledName variant="subtitle1">{name}</StyledName>
            <Typography variant="body2" color="textSecondary">
                {t('settings.socialMedia.loginWithPlatform', {
                    platform: name,
                })}
            </Typography>

            <StyledButtonContainer>
                <IconButton size="small">
                    <Icon
                        name="SettingsOutlinedIcon"
                        size={25}
                        sx={{ color: theme.palette.primary.main }}
                    />
                </IconButton>
                <Button variant={'contained'} color={'primary'}>
                    {isConnected
                        ? t('settings.socialMedia.disconnect')
                        : t('settings.socialMedia.connect')}
                </Button>
            </StyledButtonContainer>
        </StyledSocialCard>
    );
};

export default SocialMediaCard;
